import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

export const camelTitle = (s) => (upperFirst(camelCase(s)));
